import {
  InvestigationRecencyBucket,
  type InvestigationRecencyBucketType,
} from "#src/routes/investigations/history/groupInvestigationsByRecency";

export const getInvestigationRecencyBucketLabel = (
  bucket: InvestigationRecencyBucketType
): string => {
  switch (bucket) {
    case InvestigationRecencyBucket.TODAY:
      return "Today";
    case InvestigationRecencyBucket.YESTERDAY:
      return "Yesterday";
    case InvestigationRecencyBucket.LAST_7_DAYS:
      return "Last 7 Days";
    case InvestigationRecencyBucket.LAST_30_DAYS:
      return "Last 30 Days";
    case InvestigationRecencyBucket.OLDER:
      return "Older";
    default:
      return bucket;
  }
};
